// Same-origin return path policy shared by the worker and the browser client.
// Browsers treat a backslash after the leading slash as a scheme-relative URL
// (for example "/\evil.example" navigates to https://evil.example), so only
// plain absolute paths without control characters or backslashes are kept.
export function safeReturnPath(value: string | null | undefined): string {
  if (!value || !value.startsWith('/') || value.startsWith('//') || /[\\\x00-\x20]/.test(value))
    return '/';
  return value;
}
